import React from 'react';
import classNames from 'classnames';
import { indexOf } from 'lodash';

const NavTabButton = ({
  value,
  onTabClick,
  disabled = false,
  selected = false,
  hideLeftBorder = false,
  hideRightBorder = false,
}) => (
  <button
    type="button"
    onClick={() => onTabClick(value)}
    disabled={disabled}
    className={classNames('p-2 border rounded-t-lg font-bold text-lg w-full', {
      'text-brand font-bold border-b-0': selected,
      'text-brand': !selected,
      'text-highlighted cursor-not-allowed': disabled,
      'cursor-pointer': !disabled,
      'border-l-0': hideLeftBorder,
      'border-r-0': hideRightBorder,
    })}
  >
    { value }
  </button>
)

export const NavTabContent = ({ className, children }) => (
  <div className={classNames('border rounded border-t-0', className)}>
    { children }
  </div>
)

export const NavTabGroup = ({
  onTabSelected,
  selectedTab,
  className = '',
  options = [],
}) => {
  const selectedIndex = indexOf(options, ({ value }) => value === selectedTab);
  return (
    <div className={classNames('flex justify-start items-center w-full', className)}>
      {
        options.map((option, index) => (
          <NavTabButton
            key={option.value}
            value={option.value}
            selected={selectedTab === option.value}
            disabled={option.disabled}
            onTabClick={onTabSelected}
            hideLeftBorder={selectedIndex - 1 === index}
            hideRightBorder={selectedIndex + 1 === index}
          />
        ))
      }
    </div>
  );
}

export default NavTabGroup;
